export const ActivityDateText = ({startDate, endDate} : {startDate: string, endDate: string}) => {
  return (
    <>
      Showing Activity from <strong>{startDate}</strong> to <strong>{endDate}</strong>
    </>
  );
};